import { render, staticRenderFns, recyclableRender, components } from "./tn-column-notice.vue?vue&type=template&id=1a5a20c1&scoped=true&"
var renderjs
import script from "./tn-column-notice.vue?vue&type=script&lang=js&"
export * from "./tn-column-notice.vue?vue&type=script&lang=js&"
import style0 from "./tn-column-notice.vue?vue&type=style&index=0&id=1a5a20c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../软件/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5a20c1",
  null,
  false,
  components,
  renderjs
)

export default component.exports